import { Field, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'

/** The id a record carries in the system it was synced to or from. */
@ObjectType()
@InputType('SyncInfoInput')
export class SyncInfo {
  @Field(() => String, { nullable: true })
  @Prop({ type: String })
  externalId?: string
}
